import React from "react";
import AppRoutes from "./Routes";

function App() {
  return (
    <div className="">
      <AppRoutes />
    </div>
  );
}

export default App;
